<template>
    <Header
        :page-title="title"
    ></Header>
    <div class="page-content cus-content">
        <businessNav
            :nav-data="navData"
            @navClick="navClick"
        ></businessNav>
        <div class="page-content-html">
            <div class="page-content-full-img">
                <img :src="rtData.imgs">
            </div>
        </div>
        <pageTool></pageTool>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import businessNav from "@/components/nav/businessNav"
import pageTool from "@/components/nav/pageTool"
import { onMounted, reactive, getCurrentInstance } from 'vue'
const banner = require('@/assets/img/page_banner_0.png')
const businessIcon0 = require('@/assets/img/business_1.png')
const businessIcon1 = require('@/assets/img/business_2.png')
const businessIcon2 = require('@/assets/img/business_0.png')
import { getProcessDetail } from '@/api/policy'
import { useRouter } from "vue-router"
export default {
    name: "Home",
    setup() {
        const router = useRouter()
        const title = {
            cn: '备案证办理',
            en: 'Filing certificate',
            hasSearch: false,
            titleStyle: true,
            banner
        }
        const rtData = reactive({
            listData: [],
            imgs: '',
        })
        const initList = async () => {
            const internalInstance = getCurrentInstance()
            const data = await getProcessDetail({secondCategoryId: 200024})
            rtData.imgs = internalInstance.appContext.config.globalProperties.$imgUrl + data.imgs
        }
        const navData = {
            menuNames: [{name: '业务介绍', icon: businessIcon0}, {name: '业务流程', icon: businessIcon1}, {name: '业务办理', icon: businessIcon2}],
            activeName: '业务流程'
        }
        const navClick = (name) => {
            if (name == '业务介绍') {
                router.push({ name: 'Filing'})
            } else if (name == '业务办理') {
                router.push({ name: 'FilingCertificate'})
            }
        }
        onMounted(() => {
            initList()
        })
        return {
            title,
            rtData,
            navData,
            navClick,
            initList
        }
    },
    components: {
        Header,
        businessNav,
        pageTool
    }
}
</script>

<style scoped lang="stylus">
.page-content {
    padding 20px 30px
    .page-content-full-img img{
        width 100%
    }
}
</style>